import Logger from '../_00_elements/tools/logger/logger';
import requests from '../_00_elements/tools/requests-mixin';

export default {
  mixins: [ requests ],
  methods: {
    /**
     * Enable Setting
     */
    enableUserSetting(settingURL) {
      this.post(settingURL).catch((error) => Logger.error(error));
    },
  },
};
